import { type AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

const defaultOptions = {
  baseURL: '/api/srm/v1/',
};

export type ExternalAccessEndPoint = {
  method: string;
  name: string;
  path: string;
  tag: string;
};
export class ExternalAPI {
  static getEndpoints(options?: AxiosRequestConfig) {
    return srmInstance.get<ExternalAccessEndPoint[]>(
      '/external/access_tags' as any,
      {
        ...defaultOptions,
        ...options,
      },
    );
  }
}